import { Tag } from 'antd'
import React from 'react'

const CustomTag = ({ type, text = '' }) => {
	const tagStyle = {
		default: { bgColor: '#b5b5c3', textColor: '#fff' },
		success: { bgColor: '#e3ffee', textColor: '#09ae4b' },
		warning: { bgColor: '#fff0db', textColor: '#ff9e15' },
		error: { bgColor: '#ffdede', textColor: '#cc0000' },
		info: { bgColor: '#E7F6FF', textColor: '#00A3FF' },
		red: { bgColor: '#ffdede', textColor: '#cc0000' },
		AE4B: { bgColor: '#e3ffee', textColor: '#09AE4B' },
		CDD08C: { bgColor: '#fff0db', textColor: '#CDD08C' },
		wait: { bgColor: '#E7F6FF', textColor: '#5e6278' },
	}

	const statusText = new Map()
	statusText.set('info', ['chờ tiếp nhận', 'đã tiếp nhận', 'đã xuất hóa đơn'])
	statusText.set('red', ['hủy'])
	statusText.set('AE4B', ['lấy thành công'])
	statusText.set('CDD08C', ['đang xử lý'])
	statusText.set('wait', ['chờ xử lý'])
	statusText.set('warning', [
		'đã lấy hàng',
		'đang vận chuyển',
		'chờ vận chuyển',
		'đang đi phát',
		'đang xử lý',
		'chưa xuất hóa đơn',
	])
	statusText.set('success', [
		'phát thành công',
		'hoàn thành',
		'đang chuyển hoàn',
		'đã thanh toán',
		'đã chuyển hoàn',
	])
	statusText.set('error', [
		'thất lạc',
		'tịch thu',
		'tiêu huỷ',
		'nháp',
		'từ chối',
		'chưa thanh toán',
	])

	const getStyleTag = (input) => {
		for (const [type, array] of statusText) {
			if (array.includes(input.toLowerCase())) {
				return type
			}
		}

		return 'default'
	}

	return (
		<Tag
			color={tagStyle[type || getStyleTag(text)].bgColor}
			style={{ color: tagStyle[type || getStyleTag(text)].textColor }}
			className="custom-tag"
		>
			{<span style={{ fontSize: 12 }}>{text}</span>}
		</Tag>
	)
}

export default CustomTag
